import { Toaster as Sonner, toast } from "sonner";
import { usePaintedTheme } from "@/contexts/ThemeContext";
type ToasterProps = React.ComponentProps<typeof Sonner>;
const Toaster = ({
  ...props
}: ToasterProps) => {
  const theme = usePaintedTheme();
  return <Sonner theme={theme} toastOptions={{
    classNames: {
      toast: "group toast group-[.toaster]:rounded-[14px] group-[.toaster]:border group-[.toaster]:border-[hsl(var(--ec-line-strong))] group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:shadow-[var(--shadow-lg)] group-[.toaster]:font-sans",
      description: "group-[.toast]:text-[hsl(var(--ec-text-2))]",
      actionButton: "group-[.toast]:rounded-[8px] group-[.toast]:bg-primary group-[.toast]:font-semibold group-[.toast]:text-primary-foreground",
      cancelButton: "group-[.toast]:rounded-[8px] group-[.toast]:bg-foreground/[0.06] group-[.toast]:text-foreground",
      icon: "group-[.toast]:text-[hsl(var(--ec-mint))]",
      error: "group-[.toaster]:border-destructive/50",
    }
  }} className="toaster group bg-primary-foreground text-primary" />;
};
export { Toaster, toast };